import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Box, Column } from 'seagull';
import { relationshipModel } from '~/models';
import AllSetPageWithAnimations from '../../../../AllSetStep/AllSetPageWithAnimations';
import PendingAdditionalSignaturesWithAnimations from '../../../../RelationshipSignedStep/PendingAdditionalSignaturesWithAnimations';
import { Footer } from '../../Footer/Footer';
import { Header } from '../../Header/Header';
import { contentTransition, contentVariants } from '../animations';
import { StepContent } from '../StepContent';
import { GetStepsContainerTID } from './StepsContainer';
import styles from './StepsContainerDesktop.module.scss';
export const StepsContainerDesktop = (param)=>{
    let { testId, currentStep, direction, onBack, onNext, relationship, statement, isStatementAccepted, onStatementChange, isNextDisabled, hideNextButton, hasSignedSuccess } = param;
    const { StepsContainerTestIds } = useMemo(()=>GetStepsContainerTID(testId), [
        testId
    ]);
    const signedSuccessContent = hasSignedSuccess && /*#__PURE__*/ _jsx(motion.div, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.3,
            ease: 'linear'
        },
        className: styles.motionWrapper,
        children: relationshipModel.isApproved(relationship) ? /*#__PURE__*/ _jsx(AllSetPageWithAnimations, {
            relationship: relationship
        }) : /*#__PURE__*/ _jsx(PendingAdditionalSignaturesWithAnimations, {})
    }, "signed-success");
    return /*#__PURE__*/ _jsx(Box, {
        className: "".concat(styles.gradientWrapper, " ").concat(hasSignedSuccess ? styles.gradientWrapperSignedSuccess : ''),
        testId: StepsContainerTestIds.Root(),
        children: /*#__PURE__*/ _jsxs(Column, {
            className: styles.inner,
            children: [
                !hasSignedSuccess && /*#__PURE__*/ _jsx(Header, {
                    currentStep: currentStep,
                    relationship: relationship,
                    onBack: onBack,
                    testId: testId
                }),
                /*#__PURE__*/ _jsx(Column, {
                    className: styles.content,
                    testId: StepsContainerTestIds.Content(),
                    children: /*#__PURE__*/ _jsx(Column, {
                        className: styles.contentInner,
                        children: /*#__PURE__*/ _jsx(AnimatePresence, {
                            initial: false,
                            mode: "wait",
                            custom: direction,
                            children: hasSignedSuccess ? signedSuccessContent : /*#__PURE__*/ _jsx(motion.div, {
                                custom: direction,
                                variants: contentVariants,
                                initial: "enter",
                                animate: "center",
                                exit: "exit",
                                transition: contentTransition,
                                className: styles.motionWrapper,
                                children: /*#__PURE__*/ _jsx(StepContent, {
                                    currentStep: currentStep
                                })
                            }, currentStep)
                        })
                    })
                }),
                !hasSignedSuccess && /*#__PURE__*/ _jsx(Footer, {
                    currentStep: currentStep,
                    relationship: relationship,
                    onNext: onNext,
                    testId: testId,
                    isNextDisabled: isNextDisabled,
                    hideNextButton: hideNextButton,
                    statement: statement,
                    isStatementAccepted: isStatementAccepted,
                    onStatementChange: onStatementChange
                })
            ]
        })
    });
};
